module.exports = __webpack_public_path__ + "static/contact-f80f995079e4df16609b6cd334dcfb29.jpg";